import * as React from 'react';
import { buildClassnames } from './header-region';
export var SubHeader = function (props) {
  var classes = buildClassnames('sub-header', props.className);
  return React.createElement("div", {
    className: classes
  }, props.children);
};